module.exports = __webpack_public_path__ + "img/txlx_danxuanti.055fbb25.png";